/**
 * StateLegend — chip orizzontali coi 6 stati delle bollette.
 *
 * Replica del mobile (StateLegend del componente Invoices):
 * pallino colorato + label, per aiutare l'utente a interpretare
 * il colore del badge nella BillCard.
 */

const STATES = [
  { label: 'Pagata', color: 'bg-success' },
  { label: 'In scadenza', color: 'bg-warning' },
  { label: 'Da pagare', color: 'bg-secondary' },
  { label: 'Scaduta', color: 'bg-destructive' },
  { label: 'Rateizzata', color: 'bg-tertiary' },
  { label: 'Stornata', color: 'bg-muted-foreground' },
] as const

export function StateLegend() {
  return (
    <div
      className="flex flex-wrap items-center gap-x-4 gap-y-2 rounded-xl border border-border bg-muted/30 px-4 py-3"
      aria-label="Legenda stati bollette"
    >
      {STATES.map((s) => (
        <span
          key={s.label}
          className="inline-flex items-center gap-1.5 text-xs font-medium text-muted-foreground"
        >
          <span className={`h-2 w-2 rounded-full ${s.color}`} aria-hidden />
          {s.label}
        </span>
      ))}
    </div>
  )
}
